import React from 'react';
import * as styles from './filled.module.scss';

interface IFilledButtonProps {
  type?: 'submit' | 'button';
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
}

export const FilledButton = ({ type = 'button', onClick, children }: IFilledButtonProps) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {onClick ? (
      <button
        className={styles.filledButton}
        type={type === 'button' ? 'button' : 'submit'}
        onClick={(e) => onClick(e)}
      >
        {children}
      </button>
    ) : (
      <div className={styles.filledButton}>{children}</div>
    )}
  </>
);
